import { useMemo } from 'react';
import { HomeVehicleMosaic } from './HomeVehicleMosaic';

interface HomeZeroKmProps {
  vehicles: any[];
  store: any;
}

export function HomeZeroKm({ vehicles, store }: HomeZeroKmProps) {
  const show = !!store?.ad?.showZeroKm;

  const pool = useMemo(
    () =>
      vehicles
        .filter((v) => v.isZeroKm || v.mileage === 0)
        .slice(0, 20),
    [vehicles]
  );

  if (!show || pool.length === 0) return null;

  return (
    <HomeVehicleMosaic
      id="zerokm"
      title="Zero KM"
      lead="Veículos 0 km prontos para entrega, com procedência e condições especiais."
      vehicles={pool}
      viewAllHref="/estoque?type=zerokm"
      viewAllLabel="Ver todos os Zero KM"
      nextLabel="Próximos Zero KM"
    />
  );
}
